/* eslint-disable react/prop-types */
/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';

const MdIcon = (props) => {
  const { size, color, icon, display } = props;

  return <Icon path={icon} size={size} color={color} display={display} />;
};

MdIcon.defaultProps = {
  size: 16,
  color: '#fff',
  display: 'flex',
  position: 'absolute',
};

MdIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

export default MdIcon;
